import { render, staticRenderFns } from "./AdminTuitionPage.vue?vue&type=template&id=334c8a3a&"
import script from "./AdminTuitionPage.vue?vue&type=script&lang=js&"
export * from "./AdminTuitionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports